module.exports = __webpack_public_path__ + "static/img/11.6fc7c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/11.png
// module id = v7yE
// module chunks = 0